import React, { useState } from 'react'
import { Avatar, WithCloseButton } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import {
    Box,
    Collapse,
    Typography,
    Radio,
    FormControlLabel,
    styled,
} from '@mui/material'
import PeopleSearch from 'components/Filters/PeopleSearch'
import { useAuthState } from 'packages/core'
import { useTranslation } from 'react-i18next'
import config from 'config'
import { imagesDisabled } from 'utils'

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    padding: '0.6rem',
    '& .MuiFormControlLabel-label': {
        color: '#767676',
    },
    '&.Mui-checked, &.Mui-checked .MuiFormControlLabel-label': {
        color: '#000000',
    },
}))

const StyledRadio = styled(Radio)(({ theme }) => ({
    padding: '0px 1.2rem 0px 0px',
}))

const PersonFilterSomeoneElseIndicator = styled(WithCloseButton)({
    borderRadius: '0.5rem',
    backgroundColor: '#535b62',
    padding: '1rem 2.2rem 1rem 1.6rem',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
})

const StyledRadioComponent = ({ checked, label, onChange }) => {
    return (
        <StyledFormControlLabel
            checked={checked}
            label={label}
            labelPlacement="end"
            control={
                <StyledRadio
                    icon={<Icon name="Radio" />}
                    checkedIcon={<Icon name="RadioFilled" />}
                />
            }
            onChange={onChange}
        />
    )
}

const PersonFilter = ({ value, onChange, onClear, ...rest }) => {
    const { t } = useTranslation()
    const [{ currentUserId }] = useAuthState()

    const isForMe = currentUserId === value?.id

    const [someoneElse, setSomeoneElse] = useState(!isForMe && value !== null)

    const changePerson = (payload) => {
        onChange(payload)
    }

    const resetPerson = () => {
        onClear()
    }

    return (
        <>
            {someoneElse && value && !isForMe ? (
                <Box padding="0px 2rem 0px 2rem">
                    <PersonFilterSomeoneElseIndicator
                        onClose={() => {
                            setSomeoneElse(false)
                            changePerson(null)
                        }}
                    >
                        {!imagesDisabled && (
                            <Box sx={{ marginRight: '2.1rem' }}>
                                <Avatar
                                    src={`${config.BASE_EID_URL}${value.imageThumbUrl}`}
                                />
                            </Box>
                        )}
                        <Typography
                            sx={{
                                wordBreak: 'break-all',
                            }}
                            variant="body1"
                        >
                            {value.friendlyName}
                        </Typography>
                    </PersonFilterSomeoneElseIndicator>
                </Box>
            ) : (
                <>
                    <Box
                        padding="0px 2rem 0px 2rem"
                        display="flex"
                        alignItems="center"
                        flexWrap="wrap"
                    >
                        <StyledRadioComponent
                            label={t('Anybody')}
                            checked={value === null && !someoneElse}
                            onChange={() => {
                                changePerson(null)
                                setSomeoneElse(false)
                            }}
                        />
                        <StyledRadioComponent
                            label={t('Myself')}
                            checked={isForMe && !someoneElse}
                            onChange={() => {
                                setSomeoneElse(false)
                                resetPerson()
                            }}
                        />
                        <StyledRadioComponent
                            label={t('SomeoneElse')}
                            checked={someoneElse}
                            onChange={() => {
                                setSomeoneElse(true)
                            }}
                        />
                    </Box>
                    {someoneElse && (
                        <Box padding="2rem 2rem 0px 2rem">
                            <Collapse in={someoneElse}>
                                <Box>
                                    <PeopleSearch
                                        label={t('SomeoneElse')}
                                        onChange={(_, value) =>
                                            changePerson(value)
                                        }
                                        {...rest}
                                        excludeOptions={currentUserId}
                                    />
                                </Box>
                            </Collapse>
                        </Box>
                    )}
                </>
            )}
        </>
    )
}

export default PersonFilter
